import { useState, useEffect } from 'react';
import { LoadingProperties } from '../common/common.interfaces';
import './LoadingComponent.css';

export default function LoadingScreen(props: LoadingProperties) {
  if (!props.visible) return null;

  return (
    <div className="center-container">
      <div className="crystal-ball">
        <span>🔮</span>
      </div>

      <div className='step-section'>
        <span className='loading-step'>{props.step || 'Loading'}</span>
        <br/><br/>
        <span className='loading-substep'>{props.subStep || 'Please wait...'}</span>
      </div>

    </div>
  );
}